export default {
    dependencies: ['$element', 'favoritesservice'],
    callable($editPanelElement, favoritesService) {
        const editListButton = $editPanelElement.querySelector(
            '[data-edit-list-button]'
        );
        const editPanel = $editPanelElement.querySelector('[data-edit-panel]');
        const favoriteListTitleField = $editPanelElement.querySelector(
            '[data-favorite-list-title]'
        );
        const renameFavoriteListBtn = $editPanelElement.querySelector(
            '[data-rename-favorite-list-btn]'
        );
        const headerTitleElement = document.querySelector(
            '[data-favorite-list-header-title]'
        );

        let newFavoriteListTitle;
        let isEditMode = false;
        const initialEditListButtonText = editListButton.textContent;

        if (editListButton) {
            editListButton.addEventListener('click', toggleEditMode);
        }

        if (renameFavoriteListBtn) {
            renameFavoriteListBtn.addEventListener('click', renameFavoriteList);
        }

        function toggleEditMode() {
            isEditMode = !isEditMode;
            if (isEditMode) {
                unhideElement(editPanel);
                editListButton.textContent = 'Ferdig';
            } else {
                hideElement(editPanel);
                editListButton.textContent = initialEditListButtonText;
            }
        }

        function unhideElement(element) {
            element.setAttribute('aria-hidden', 'false');
            element.classList.remove('hidden');
        }

        function hideElement(element) {
            element.setAttribute('aria-hidden', 'true');
            element.classList.add('hidden');
        }

        function renameFavoriteList() {
            newFavoriteListTitle = favoriteListTitleField.value.trim();
            const favoriteListId = $editPanelElement.getAttribute(
                'data-favorite-list-id'
            );

            favoritesService
                .renameList(favoriteListId, newFavoriteListTitle)
                .then(replaceFavoriteTitle)
                .catch(displayDeleteListErrorMessage);

            toggleEditMode();
        }

        function replaceFavoriteTitle() {
            if (headerTitleElement) {
                headerTitleElement.textContent = newFavoriteListTitle;
            }
        }

        function displayDeleteListErrorMessage() {
            // eslint-disable-next-line no-alert
            alert('Vi kunne ikke slette listen - prøv igjen senere');
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/favoriteEditList.js